export default "__VITE_ASSET__DjBLa2xW__"